module.exports = __webpack_public_path__ + "static/media/studio-kitchen.73808036.jpg";